<template>
  <v-card v-show="!close">
    <div class="window-border" :style="{ background: borderColor }"></div>
    <div class="window-header">
      <div class="window-title">{{ title }}</div>
      <div class="window-menu">
        <v-icon class="window-icons" style="height: 19px" @click="minimize = !minimize">minimize</v-icon>
        <v-icon class="window-icons" @click="close = true">close</v-icon>
      </div>      
    </div>
    <v-divider style="margin: 0px 5px;"></v-divider>
    <div :class="{ 'window-context': true, 'window-minimize': minimize }" :style="{ maxHeight: maxHeight }">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'Window',
  props: {
    title: String,
    borderColor: String,
    maxHeight: [String],
  },
  data() {
    return {
      minimize: false,
      close: false,
    };
  },
}
</script>

<style lang="scss">
.window-border {
  height: 4px;
}

.window-header {
  padding: 10px;
  display: flex;
  justify-content: space-between;

  .window-title {
    color: #313131;
    font-size: 18px;
    font-family: 'Source Sans Pro',sans-serif;
  }

  .window-icons {
    color: #c3c3c3;
    font-size: 16px;
    font-weight: bold;
    margin-right: 4px;
    cursor: pointer;

    &:hover {
      color: #333333;
    }
  }
}

.window-context {
  height: 100%;
  // max-height: 500px;
  transition: max-height .6s ease-out;
  overflow: auto;
}

.window-minimize {
  max-height: 0px;
  padding: 0px;
}
</style>
